<template>
    <div class="question mb-4">
        <div class="mb-3">
            <div class="question__title">Как Вы считаете, какое из перечисленных ниже событий оказало наибольшее влияние на  Ваше владение навыками в различных целях?
            </div>
            <div class="question__desc caption">Оцените эту степень влияния в правых колонках в баллах   от 1 до 5-ти, где 1-не оказало влияния, 5- оказало  сильное влияние (0- затрудняюсь ответить)</div>
        </div>

        <table class="table-skills">
            <thead class="table-skills__header">
                <tr>
                    <td>Наименование событий</td>
                    <td>Владение навыками, связа-нными с профессиональной деятельностью</td>
                    <td>Владение навыками, для повседневной жизни</td>
                    <td>Владение навыками социально-эмоциональной коммуникаци в социальных группах</td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(id, index) in ids" v-if="index%3 === 0" :key="id">
                    <td v-if="list[id].text">{{ list[id].text }}</td>
                    <td>
                        <question-radio
                                has-index
                                :index-offset="-1"
                                v-if="list[ids[index]].type === 'radio' && list[ids[index]].answers.length"
                                :isSingle="true"
                                :horizontal="!!list[ids[index]].is_horizontal"
                                :items="list[ids[index]].answers"
                                @input="$emit('sendAnswer', $event, ids[index])"
                        />
                        <question-input
                                v-else-if="list[ids[index]].type === 'input'"
                                @input="$emit('sendAnswer', $event, ids[index])"
                        />
                    </td>
                    <td>
                        <question-radio
                                has-index
                                :index-offset="-1"
                                :isSingle="true"
                                v-if="list[ids[index + 1]].type === 'radio' && list[ids[index + 1]].answers.length"
                                :horizontal="!!list[ids[index + 1]].is_horizontal"
                                :items="list[ids[index + 1]].answers"
                                @input="$emit('sendAnswer', $event, ids[index + 1])"
                        />
                        <question-input
                                v-else-if="list[ids[index + 1]].type === 'input'"
                                @input="$emit('sendAnswer', $event, ids[index + 1])"
                        />
                    </td>
                    <td>
                        <question-radio
                                has-index
                                :index-offset="-1"
                                :isSingle="true"
                                v-if="list[ids[index + 2]].type === 'radio' && list[ids[index + 2]].answers.length"
                                :horizontal="!!list[ids[index + 2]].is_horizontal"
                                :items="list[ids[index + 2]].answers"
                                @input="$emit('sendAnswer', $event, ids[index + 2])"
                        />
                        <question-input
                                v-else-if="list[ids[index + 2]].type === 'input'"
                                @input="$emit('sendAnswer', $event, ids[index + 2])"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import QuestionRadio from '@/components/question/radio'
    import QuestionInput from '@/components/question/input'

    export default {
        components: {
            QuestionRadio,
            QuestionInput
        },
        props: {
            ids: Array
        },
        data () {
            return {
                items: [],
                value: ''
            }
        },
        computed: {
            ...mapGetters('questions', ['questions']),
            list () {
                let out = {}

                this.questions.forEach(item => {
                    out[item.id] = item
                })

                return out
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .question {
        &__title {}
        &__desc {
            color #777777
        }
    }

    .table-skills {
        width 100%
        border-collapse collapse

        &__header {
            text-align center
        }

        td {
            padding .5rem 1rem
            border 1px solid rgba(0,0,0,0.42)
        }
    }
</style>
